<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row mt-3">
    <div class="col-sm-12 col-md-8 offset-md-2 p-0">
    + <div class="container-fluid p-0 panel">
        <div class="row m-0 mt-5">
         <!-- <div class="col-12 h3 mt-md-5 mt-sm-5 pane-heading text-center">
           
            <img src="./assets/img/concept.png" style="margin-left:10px; margin-right: 10px;" />
          </div>-->
          <div class="col-12 h2 mt-md-5 mt-sm-5 pane-heading text-center">
           
          </div>
          <div class="col-md-12 h3 text-center">
            Omnipod 5 Launch Event - Simplicity Unlocked<br>
            <span style="font-size: large;">A New Era of Simplied Diabetes Care</span>

       
           
          </div>
         <!-- <div class="col-md-12 h4 text-center">
              <br>2nd February 2026 (14:00-16:00 UAE time) <br>9th February 2026 (11:00-13:00 UAE time)<br>11th February 2026 (14:00-16:00 UAE time)
          </div>-->
          <!-- <div class="col-md-4 text-right h3">271d 21h 41m 37s</div> -->
        </div>
        <div class="row p-3">
        <div class="col-12 d-flex justify-content-center">
  <app-timer></app-timer>
</div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-4 offset-md-4 p-4">
            <main class="form-signin p-2">
        <form>
                <h1 class="h3 mb-3 fw-normal text-center">Please sign in</h1>
                <div
                  *ngIf="f.submitted && result?.status == 'success'"
                  class="alert alert-success"
                >
                  {{ result.message }}
                  <br />
                  Dear {{ result.user.name }}
                  <br />
                  The conference will start in 2 days
                </div>
                <div
                  *ngIf="f.submitted && result?.status == 'error'"
                  class="alert alert-danger"
                >
                  {{ result.message }}
                </div>
                <form #f="ngForm" (ngSubmit)="onSummit(f)" class="hero-form">
                  <div class="form-floating">
                    <input
                      placeholder="name@example.com"
                      id="floatingInput"
                      class="form-control form-control-name"
                      type="email"
                      #email="ngModel"
                      name="email"
                      [(ngModel)]="emailVal"
                      ngModel
                      required
                      email
                    />
                    <label for="floatingInput">Email address</label>
                  </div>
                  <div
                    *ngIf="
                      (email.invalid && email.dirty) ||
                      (f.submitted && email.invalid)
                    "
                    class="alert alert-danger"
                  >
                    <div *ngIf="email.errors!.required">Email is required</div>
                    <div *ngIf="email.errors!.email">
                      Email must be a valid email address
                    </div>
                  </div>
                  <div class="form-floating">
                    <input
                      id="floatingPassword"
                      placeholder="Password"
                      class="form-control form-control-phone"
                      name="password"
                      type="password"
                      required
                      ngModel
                      #pass="ngModel"
                      minlength="6"
                      [(ngModel)]="passwordVal"
                    />

                    <label for="floatingPassword">Password</label>
                  </div>
                  <div
                    *ngIf="
                      (pass.invalid && pass.dirty) ||
                      (f.submitted && pass.invalid)
                    "
                  >
                    <div
                      *ngIf="pass.errors!.required"
                      class="alert alert-danger"
                    >
                      Password is required
                    </div>

                    <div
                      *ngIf="pass.errors!.minlength"
                      class="alert alert-danger"
                    >
                      Password minimum length must be 6 characters
                    </div>
                  </div>
                  <div class="checkbox mb-3">
                    <label>
                     
                    </label>
                  </div>
                  <input
                    type="hidden"
                    name="conference_id"
                    ngModel="{{ conference_id }}"
                  />
                  <button class="w-100 btn btn-lg btn-secondary"style="background-color:#5e22ae" type="submit">
                    Login
                  </button>
                  <br>  <br>
                   <button class="w-100 btn btn-lg btn-primary"  [routerLink]="['/', 'register']">
                    Register
                  </button>
                </form>
               

            
              
                
        
              </form>
            </main>
          </div>
        </div>
        <!-- <div class="row">
              <div class="col-md-7">
                <img src="./img/pcioname.jpeg" class="img-fluid" alt="" />
                <br /><br />
                <img src="./img/pico7.png" class="img-fluid" alt="" />
              </div>
            </div> -->
      </div>
    </div>
  </div>
  <div class="container pt-5 table-responsive" >
        <table class="table">
          <tbody>
            <tr>
              <td style="font-size: small;">
    

    

    
This invitation is exclusive to healthcare professionals
©️2026 Insulet Corporation. Insulet, Omnipod and the Omnipod logo are trademarks or registered trademarks of Insulet Corporation. All rights reserved. All other trademarks are the property of their respective owners. The use of third-party trademarks does not constitute an endorsement or imply a relationship or other affiliation. 
<br><br>
INS-OHS-04-2026-00313 v1.0
<br>
    <br>
    <br>
              </td>
            </tr>
          </tbody>
        </table>
  </div>

 
</div>
    
 
  <div class="footer m">
    <img src="./assets/img/bottom.png" class="blob-bright img-fluid" />
  </div>

<!-- end container -->

<!-- JavaScript Bundle with Popper -->
<!-- <script src="js/bootstrap.bundle.min.js"></script> -->